import React, { useState } from 'react'

import SliderStyled from 'src/pages/Aboutus/components/Slider/Slider'

import CardItemSlider from '../Slider/components/CardItemSlider'

import { LogosContainer } from './styles'

const Clients = () => {
  const [isPaused, setIsPaused] = useState(false)

  const allLogos = Array.from({ length: 24 }, (_, i) => `/images/clients/im${i}.svg`)
  const logos = allLogos.slice(10, 24)

  return (
    <LogosContainer>
      <span>Nuestros clientes</span>
      <SliderStyled isPaused={isPaused}>
        {logos.map((src, idx) => (
          <CardItemSlider key={idx} logoSrc={src} setIsPaused={setIsPaused} />
        ))}
        {logos.map((src, idx) => (
          <CardItemSlider key={`${idx}-copy`} logoSrc={src} setIsPaused={setIsPaused} />
        ))}
      </SliderStyled>
    </LogosContainer>
  )
}

export default Clients
